import { useState } from 'react';
import { useLanguage } from '../hooks/useLanguage';
import './LanguageSelector.css';

export default function LanguageSelector() {
  const { language, setLanguage, languages } = useLanguage();
  const [open, setOpen] = useState(false);

  const current = languages.find(l => l.code === language) || languages[0];

  return (
    <div className="lang-sel" onBlur={() => setOpen(false)} tabIndex={0}>
      <div className="lang-current" onClick={() => setOpen(v => !v)}>
        <span className="lang-flag">{current.flag}</span>
        <span className="lang-code">{current.code.toUpperCase()}</span>
        <span className="lang-arrow">{open ? '▴' : '▾'}</span>
      </div>
      {open && (
        <div className="lang-dropdown">
          {languages.map(l => (
            <div
              key={l.code}
              className={`lang-opt ${l.code === language ? 'lang-opt-active' : ''}`}
              onClick={() => { setLanguage(l.code); setOpen(false); }}
            >
              <span className="lang-flag">{l.flag}</span>
              <span className="lang-name">{l.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
